export var mutations = {
    setEmail: function (state, payload) {
        state.email = payload;
    },
};
